import moment from "moment";

export function redirectUser(urlPath, timeout) {
  setTimeout(function () {
    return window.location.replace(urlPath);
  }, timeout);
}

export const GetLocalStorage = (params) => {
  const value = JSON.parse(localStorage.getItem(params || "gida_token"));
  return value;
};

export const FormatCurrency = (amount, currency) => {
  const value = new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: currency || "NGN",
  }).format(amount || 0);

  return value;
};

export const FormatDateTime = (value, isDate) => {
  const timeDate = moment(value).format(isDate || "hh:mm a");

  return timeDate;
};

export const GetSearchParams = (url) => {
  const data = new URLSearchParams(window.location.search).get(url);
  return data;
};
